import React from 'react';
import PropTypes from 'prop-types';

import './NotificationRow.scss';

function NotificationRow({ isMigrateMode }) {
  if (!isMigrateMode) return null;

  return (
    <div className="create-alert-dialog-row create-alert-dialog-row-notification nohyphens">
      <section className="notification--warning">
        <div className="notification--icon">!</div>
        <div className="notification--content">
          Upon migration, the previous alert results (shown in the Results from: dropdown menu) will be lost. Please ensure to review the results before completing the migration process.
        </div>
      </section>
    </div>
  );
}

NotificationRow.propTypes = {
  isMigrateMode: PropTypes.bool,
};

export default NotificationRow;
